<template>
  <section class="vhm-shell">
    <div class="vhm-eyebrow">
      <span class="vhm-dot"></span>
      <span class="brand-mark">WaizmannVergleich</span>&nbsp;/&nbsp;ERGEBNIS
    </div>
    <h1 class="vhm-title">
      Ihr Ergebnis:
      <span class="vhm-title__sub">
        {{ berechnung.show_ber_geschlecht }},
        {{ berechnung.show_ber_geburtstag }}
      </span>
    </h1>
    <p class="vhm-sub">
      {{ berechnung.showBerechnungName }}en &middot; sortiert nach Leistung
      &amp; Preis
    </p>

    <button
      class="vhm-toggle"
      :class="{ 'vhm-toggle--open': showVorgaben }"
      @click="showVorgaben = !showVorgaben"
    >
      <span>Berechnungsvorgaben</span>
      <v-icon
        :icon="showVorgaben ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        size="18"
      />
    </button>

    <div v-if="showVorgaben" class="vhm-vorgaben">
      <ul>
        <li
          v-for="(item, index) in berechnung.berlog"
          :key="index"
          v-html="nl2br(item.value)"
        ></li>
      </ul>
      <router-link to="/vergleich/starten" class="vhm-link">
        Vorgaben anpassen →
      </router-link>
    </div>
  </section>
</template>

<script setup>
  import { ref, defineProps } from "vue";
  import { useNl2Br } from "@/composable/useNl2Br";
  const { nl2br } = useNl2Br();

  defineProps({
    tarif: { type: Object, default: () => ({}) },
    berechnung: { type: Object, default: () => ({}) },
  });
  const showVorgaben = ref(false);
</script>

<style scoped>
  .vhm-shell {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 14px 14px 12px;
    margin-bottom: 12px;
  }
  .vhm-eyebrow {
    display: inline-flex;
    align-items: center;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.7px;
    color: #5b6473;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
    margin-bottom: 4px;
  }
  .vhm-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0f4c81;
    border-radius: 1px;
    margin-right: 8px;
  }
  .vhm-title {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 2px;
    line-height: 1.3;
    letter-spacing: -0.2px;
  }
  .vhm-title__sub {
    display: block;
    color: #0f4c81;
    font-weight: 600;
    font-size: 14px;
  }
  .vhm-sub {
    font-size: 12.5px;
    color: #4b5563;
    margin: 4px 0 10px;
  }

  .vhm-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 8px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    letter-spacing: 0.2px;
    cursor: pointer;
  }
  .vhm-toggle--open {
    border-color: #0f4c81;
    background: #f0f5fa;
  }

  .vhm-vorgaben {
    margin-top: 8px;
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 10px 12px;
    font-size: 13px;
    color: #1f2937;
  }
  .vhm-vorgaben ul {
    list-style: none;
    padding: 0;
    margin: 0 0 6px;
  }
  .vhm-vorgaben li {
    padding: 1px 0;
  }
  .vhm-vorgaben li :deep(br) {
    display: none;
  }
  .vhm-link {
    font-size: 12.5px;
    color: #0f4c81;
    font-weight: 600;
    text-decoration: none;
  }
  .vhm-link:hover {
    text-decoration: underline;
  }
</style>
